import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

class MotifResolutionSelect extends React.Component {
    render() {
        const { value, onChange, motifsResolution, error, autoFocus } = this.props;
        
        let selected = value;
        if (motifsResolution.length === 0 || value === 0) {
            selected = '';
        }

        return (
            <TextField
                autoFocus={autoFocus}
                select
                required
                error={error !== undefined}
                name="motifResolutionId"
                label="Motif de résolution"
                value={selected}
                onChange={onChange}
                helperText={error ? error.errorMsg : ''}
                fullWidth>
                {motifsResolution.map(motifResolution => (
                    <MenuItem key={motifResolution.id} value={motifResolution.id} disabled={!motifResolution.autorise}>
                        {motifResolution.libelle}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}

MotifResolutionSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    motifsResolution: PropTypes.array.isRequired,
};

MotifResolutionSelect.defaultProps = {
    autoFocus: true
};

export default MotifResolutionSelect;